__turbopack_context__.v({
  "copyright-text": "footer-module-scss-module__bQmlzW__copyright-text",
  "footer": "footer-module-scss-module__bQmlzW__footer",
  "link-list": "footer-module-scss-module__bQmlzW__link-list",
  "list-item": "footer-module-scss-module__bQmlzW__list-item",
  "logo": "footer-module-scss-module__bQmlzW__logo",
  "logo-link": "footer-module-scss-module__bQmlzW__logo-link",
  "placeholder": "footer-module-scss-module__bQmlzW__placeholder",
  "text-cta": "footer-module-scss-module__bQmlzW__text-cta",
});
